import { render } from "./CodeDetails.vue?vue&type=template&id=c08e3758&scoped=true"
import script from "./CodeDetails.vue?vue&type=script&lang=js"
export * from "./CodeDetails.vue?vue&type=script&lang=js"

import "./CodeDetails.vue?vue&type=style&index=0&id=c08e3758&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08e3758"]])

export default __exports__